// extracted by mini-css-extract-plugin
export var buttonContainer = "_8r-1";
export var fontSizeSelect = "_8r-3";
export var formatSelect = "_8r-2";
export var formats = "_8r-4";
export var hidden = "_8r-5";
export var icon = "_8r-6";
export var select = "_8r-0";